import { filterPhoneNumber } from 'src/utils/helpers.js';
class ContactInfo {
  constructor(params) {
    this.email = params.email;
    this.phoneNumber = filterPhoneNumber(params.phoneNumber);
    return this;
  }
}
export { ContactInfo as default };
